import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';

export const useCreateAnnotation = () => {
    const [{ db }] = useStore(StoreTypes.db);
    const { readAnnotationById } = useReadAnnotations();

    const createAnnotation = useCallback(async ({ id, bookId, type, annotations = [], isDirty = false, pageIndex = 0, name = '', lastSyncedAt = null, marks = [] }) => {
        await db.annotation.put({ id, bookId, type, annotations, isDirty, pageIndex, name, updatedAt: Date.now(), lastSyncedAt, marks });
        return readAnnotationById({ id });
    }, [db.annotation, readAnnotationById]);

    return createAnnotation;
};

export const useUpdateAnnotation = () => {
    const [{ db }] = useStore(StoreTypes.db);
    const { readAnnotationById } = useReadAnnotations();

    const updateAnnotation = useCallback(async (id, payload) => {
        await db.annotation.update(id, payload);
        return readAnnotationById({ id });
    }, [db.annotation, readAnnotationById]);

    return updateAnnotation;
};

export const useDeleteAnnotation = () => {
    const [{ db }] = useStore(StoreTypes.db);
    const { readAnnotationById } = useReadAnnotations();

    const deleteAnnotation = useCallback(async (id) => {
        await db.annotation.delete(id);
        return readAnnotationById({ id });
    }, [db.annotation, readAnnotationById]);

    return deleteAnnotation;
};

export const useMarkAnnotationSynced = () => {
    const [{ db }] = useStore(StoreTypes.db);

    const markAnnotationSynced = useCallback(async ({ id, lastSyncedAt }) => {
        return db.annotation.update(id, { isDirty: false, lastSyncedAt });
    }, [db.annotation]);

    return markAnnotationSynced;
};

export const useReadAnnotations = () => {
    const [{ db }] = useStore(StoreTypes.db);

    const readAnnotationById = useCallback(async ({ id }) => {
        return db.annotation.get({ id });
    }, [db.annotation]);

    const readAnnotations = useCallback(async ({ bookId, annotationType }) => {
        const condition = {};
        if (bookId) {
            condition.bookId = bookId;
        }
        if (annotationType) {
            condition.type = annotationType;
        }
        return db.annotation.where(condition).toArray();
    }, [db.annotation]);

    return {
        readAnnotationById,
        readAnnotations,
    }
};


//painterInfo db
export const useCreateReaderToolSettings = () => {
    const [{ readerToolSettingsDB }] = useStore(StoreTypes.db);
    const readReaderToolSettingsById = useReadReaderToolSettings();

    const createReaderToolSettings = useCallback(async (id, payload) => {
        const existedRecord = await readReaderToolSettingsById(id);
        readerToolSettingsDB.readerToolSettings.put({ ...(existedRecord || { id }), ...payload });
    }, [readReaderToolSettingsById, readerToolSettingsDB.readerToolSettings]);

    return createReaderToolSettings;
};

export const useReadReaderToolSettings = () => {
    const [{ readerToolSettingsDB }] = useStore(StoreTypes.db);
    const readReaderToolSettingsById = useCallback(async (id) => {
        try {
            const existedRecord = await readerToolSettingsDB.readerToolSettings.get({ id });
            return existedRecord
        } catch (e) {
            console.log("no readerToolSettingsDB")
        }
    }, [readerToolSettingsDB.readerToolSettings]);

    return readReaderToolSettingsById
};
